module.exports = __webpack_public_path__ + "static/color.91cd6009.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/color.png
// module id = 465
// module chunks = 246384609461072